import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import OrderThin from "domain/orderThin";
import { formatNumber } from "common/formatters";
import './WorkingOrdersAlertModal.scss';

export type WorkingOrdersAlertModalProps = {
    showModal: boolean;
    accountName: string;
    orders: OrderThin[];
    onWorkingOrdersAlertModalCancel: () => void;
};

const WorkingOrdersAlertModal: React.FC<WorkingOrdersAlertModalProps> = ({
    showModal,
    accountName,
    orders,
    onWorkingOrdersAlertModalCancel
}) => {
    return (
        <Modal show={showModal} centered onHide={onWorkingOrdersAlertModalCancel}>
            <Modal.Header>
                <Modal.Title>
                    Some Working Orders Are Still Tied To This FCM Account: {accountName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Please cancel the following working orders before deleting the FCM Account.
                </p>
                <div className="working-offers-alert-modal" style={{ width: "100%" }}>
                    <Table striped>
                        <thead>
                            <tr>
                                <td>Order ID</td>
                                <td>Symbol</td>
                                <td>Quantity</td>
                            </tr>
                        </thead>
                        <tbody>
                            {orders?.map((order, index) => (
                                <tr key={'orderRow_' + index}>
                                    <td>{order.displayId}</td>
                                    <td>{order.symbol}</td>
                                    <td>{formatNumber(order.quantity)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onWorkingOrdersAlertModalCancel}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WorkingOrdersAlertModal;
